import type { Meta, StoryObj } from "@storybook/react";

import type { IconButtonProps } from "@/ui/core";
import { IconButton } from "@/ui/core";
import type { IconButtonVariant } from "@/ui/core/buttons/IconButton";
import { FAIconName } from "@/ui/core/Icon";

const IconButtonVariantValues: Record<IconButtonVariant, IconButtonVariant> = {
  "accent.blue": "accent.blue",
  "accent.critical": "accent.critical",
  primary: "primary",
  primarySolid: "primarySolid",
};

const StoryMeta: Meta<IconButtonProps> = {
  title: "Core/Icon Button",
  component: IconButton,
  argTypes: {
    accessibilityLabel: { control: "text" },
    iconName: {
      control: "select",
      options: Object.values(FAIconName),
    },
    isDisabled: { control: "boolean" },
    isLoading: { control: "boolean" },
    onPress: { action: "Icon button pressed" },
    testID: { control: "text" },
    variant: {
      control: "select",
      options: Object.values(IconButtonVariantValues),
    },
  },
  args: {
    accessibilityLabel: "Add to calendar",
    iconName: FAIconName.BookOpenReader,
    testID: "add-to-calendar",
  },
};

type Story = StoryObj<IconButtonProps>;

const Primary: Story = {};
const Disabled: Story = {
  ...StoryMeta,
  args: {
    isDisabled: true,
  },
};

const Loading: Story = {
  ...StoryMeta,
  args: {
    isLoading: true,
  },
};

const AccentBlue: Story = {
  ...StoryMeta,
  args: {
    accessibilityLabel: "Action button",
    iconName: FAIconName.Plus,
    testID: "action-button",
    variant: "accent.blue",
  },
};

export { AccentBlue, Disabled, Loading, Primary };
export default StoryMeta;
